import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useI18n();

  const cols = [
    {
      title: t.footer.navigate,
      links: [
        { label: t.sections.overview, href: "#overview" },
        { label: t.sections.philosophy, href: "#philosophy" },
        { label: t.sections.orbtech, href: "#orbtech" },
        { label: t.sections.contact, href: "#contact" },
      ],
    },
    {
      title: t.footer.ventures,
      links: [
        { label: "Orb Tech", href: "https://orbtech.ai/", external: true },
        { label: "IO", href: "https://orbtech-io-ai.lovable.app/", external: true },
      ],
    },
    {
      title: t.footer.contact,
      links: [
        { label: "connect@orb-tech.co.uk", href: "mailto:connect@orb-tech.co.uk" },
        { label: t.footer.london, href: "#contact" },
      ],
    },
  ];

  return (
    <footer
      className="relative z-10 bg-[#050505] px-6 pt-20 pb-10 sm:pl-[120px] sm:pr-16"
      data-testid="site-footer"
    >
      <div className="flex flex-col justify-between gap-16 border-t border-white/10 pt-16 lg:flex-row">
        <div className="max-w-md">
          <h2 className="font-head text-3xl font-light leading-tight tracking-tight text-white sm:text-4xl">
            {t.footer.headA}
            <span className="text-white/40"> {t.footer.headB}</span>
          </h2>
          <motion.a
            href="mailto:connect@orb-tech.co.uk"
            data-testid="footer-cta"
            whileHover={{ x: 6 }}
            className="mt-8 inline-flex items-center gap-3 rounded-full border border-white/15 px-6 py-3 font-mono-accent text-[11px] uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-[#a855f7] hover:text-[#a855f7]"
          >
            {t.footer.getInTouch}
            <ArrowUpRight className="h-4 w-4" />
          </motion.a>
        </div>

        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
          {cols.map((col) => (
            <div key={col.title}>
              <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/30">
                {col.title}
              </p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      target={l.external ? "_blank" : undefined}
                      rel={l.external ? "noopener noreferrer" : undefined}
                      className="font-body text-sm text-white/60 transition-colors duration-300 hover:text-white"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
        <span className="font-head text-xl font-semibold tracking-tight text-white">
          Orb Holdings Limited
        </span>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-white/30">
          © {new Date().getFullYear()} Orb Holdings Limited — {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}
